import(/* webpackMode: "eager" */ "/home/runner/work/snapcards/snapcards/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["GclidSync"] */ "/home/runner/work/snapcards/snapcards/src/components/GclidSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DueBadge"] */ "/home/runner/work/snapcards/snapcards/src/components/nav/DueBadge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfflineSyncBanner"] */ "/home/runner/work/snapcards/snapcards/src/components/OfflineSyncBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaddleLoader"] */ "/home/runner/work/snapcards/snapcards/src/components/PaddleLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogIdentify"] */ "/home/runner/work/snapcards/snapcards/src/components/PostHogIdentify.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TimezoneSync"] */ "/home/runner/work/snapcards/snapcards/src/components/TimezoneSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WelcomeProModal"] */ "/home/runner/work/snapcards/snapcards/src/components/WelcomeProModal.tsx");
